import React from 'react';
import errorIcon from '@images/error.svg';
import { Modal, useTranslation } from '@testsigma/atoms';
import {
  maskSensitiveInfo,
  hasSensitiveInfo,
  isInvalidGrant,
  isInvalidClient,
  isInvalidClientId,
} from '@modules/salesforce/utils/utils';
import { logErrorToSentry } from '@utils/common';
interface ErrorDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorObject: string;
  title?: string;
}

const ErrorDetailsModal: React.FC<ErrorDetailsModalProps> = ({
  isOpen,
  onClose,
  errorObject,
  title,
}) => {
  const { t } = useTranslation();

  const getErrorMessage = () => {
    if (!errorObject) return t('common.no-error-details');

    let parsedError;
    try {
      parsedError =
        typeof errorObject === 'string' ? JSON.parse(errorObject) : errorObject;
    } catch (err) {
      logErrorToSentry({ error: err });
    }

    if (hasSensitiveInfo(parsedError)) {
      return maskSensitiveInfo(parsedError.error);
    }

    if (isInvalidGrant(parsedError)) {
      return t('connection-failed-detailed-error.invalid-grant');
    }

    if (isInvalidClient(parsedError)) {
      return t('connection-failed-detailed-error.invalid-client');
    }

    if (isInvalidClientId(parsedError)) {
      return t('connection-failed-detailed-error.invalid-client-id');
    }

    return parsedError?.error;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnEscape
      closeOnOutsideClick
      className='rounded-xl relative w-[35%] text-left flex flex-col gap-4'
      showCloseButton
    >
      <div className='text-gray-500 text-center flex flex-col items-center w-fit'>
        <img
          src={errorIcon}
          className='empty-illustration'
          alt='Error Illustration'
        />
      </div>
      <h3 className='text-lg leading-7 font-semibold text-secondary-1000'>
        {title || t('connection-failed-detailed-error.label')}
      </h3>
      <div className='text-sm leading-5 text-secondary-text max-h-[250px] overflow-y-scroll'>
        <pre className='whitespace-pre-wrap'>{getErrorMessage()}</pre>
      </div>
    </Modal>
  );
};

export default ErrorDetailsModal;
